import { Box } from '@chakra-ui/react';
import { PORT_CONTAINER_CLASS } from 'constants/bounding-box';
import { PRINT_BLEED_PADDING } from 'constants/printBleed';
import { useAppSelector } from 'modules/Editor/store';
import {
  selectHasShowPrintBleed,
  selectIsScrollZooming,
  selectZoom,
} from 'modules/Editor/store/editorSettingsSelector';
import { selectInfographHeightPx, selectInfographWidthPx } from 'modules/Editor/store/infographSelector';
import { selectCropId } from 'modules/Editor/store/widgetSelector';
import { memo, useMemo } from 'react';

import LineConnector from './LineConnector';
import LineCreator from './LineCreator';
import NodeCreatorModal from './NodeCreatorModal';

const PortRenderer = () => {
  const zoom = useAppSelector(selectZoom);
  const pageWidthPx = useAppSelector(selectInfographWidthPx);
  const pageHeightPx = useAppSelector(selectInfographHeightPx);
  const cropId = useAppSelector(selectCropId);
  const isScrollZooming = useAppSelector(selectIsScrollZooming);
  const showPrintBleed = useAppSelector(selectHasShowPrintBleed);

  const scaledPageHeight = useMemo(() => `${pageHeightPx * zoom}px`, [pageHeightPx, zoom]);
  const scaledPageWidth = useMemo(() => `${pageWidthPx * zoom}px`, [pageWidthPx, zoom]);

  const wrapperProps = showPrintBleed
    ? {
        mt: '1rem',
        mb: '10',
        p: `${PRINT_BLEED_PADDING * zoom}px`,
        w: 'fit-content',
        position: 'relative' as 'relative',
        overflow: 'visible',
      }
    : {};

  // don't show ports in crop mode or zooming
  if (cropId || isScrollZooming) return null;

  return (
    <Box {...wrapperProps}>
      <Box
        className={PORT_CONTAINER_CLASS}
        pointerEvents='none'
        zIndex='port'
        position='relative'
        height='100%'
        marginRight={0}
      >
        <Box
          display='block'
          position='relative'
          top={0}
          left={0}
          width={scaledPageWidth}
          height={scaledPageHeight}
          pointerEvents='none'
        >
          <LineCreator zoom={zoom} />
          <LineConnector zoom={zoom} />
          <NodeCreatorModal zoom={zoom} />
        </Box>
      </Box>
    </Box>
  );
};

export default memo(PortRenderer);
